// ============================================================================
// videoSource — выбор источника видео по возможностям браузера (SSoT).
//
// Браузер не всегда умеет контейнер (mov/mkv/avi) или кодек внутри mp4 —
// тогда сервер отдаёт перекодированный MP4 (query `transcode=mp4`), а не
// «пустое окно». Переключение ОДНО: повторных запросов на каждый кадр нет.
// ============================================================================

import { fileExt } from '@/lib/fileName';

/** Формат перекодирования, который понимает сервер. */
export const TRANSCODE_FORMAT = 'mp4';

const VIDEO_MIME: Record<string, string> = {
  mp4: 'video/mp4',
  m4v: 'video/mp4',
  webm: 'video/webm',
  mov: 'video/quicktime',
  mkv: 'video/x-matroska',
  avi: 'video/x-msvideo',
  ogv: 'video/ogg',
};

/** MIME контейнера видео по имени файла ('' — неизвестен). */
export function videoMimeForName(name?: string): string {
  if (!name) return '';
  return VIDEO_MIME[fileExt(name)] || '';
}

/** Уверенно ли браузер объявил контейнер неподдерживаемым.
 *  canPlayType: '' — точно нет; 'maybe'/'probably' — пробуем оригинал
 *  (кодек внутри контейнера проверяется уже по факту ошибки). */
export function canPlayVideoContainer(name?: string): boolean {
  const mime = videoMimeForName(name);
  if (!mime || typeof document === 'undefined') return true;
  try {
    const probe = document.createElement('video');
    return probe.canPlayType(mime) !== '';
  } catch {
    // Проверка недоступна — не мешаем воспроизведению оригинала.
    return true;
  }
}

/** Стриминговый адрес файла (а не blob:/data: — их перекодировать нечем). */
export function isFileStreamUrl(url: string): boolean {
  return /^\/files\//.test(url || '');
}

/** URL уже запрошен с перекодированием. */
export function hasTranscodeParam(url: string): boolean {
  return /[?&]transcode=/.test(url || '');
}

/** Адрес того же файла с перекодированием ('' — недоступен/уже запрошен). */
export function transcodeUrl(url: string, format = TRANSCODE_FORMAT): string {
  if (!url || hasTranscodeParam(url)) return '';
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}transcode=${encodeURIComponent(format)}`;
}
